import { FormikHelpers } from 'formik';
import * as authApi from '@Requests';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useAuth, useFeedback, useTitleBar } from '@Providers';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '@Routes';
import ChangePasswordPage from './ChangePasswordPage';

export interface PasswordValues {
currentPassword: string;
   newPassword: string;
   confirmPassword: string;
}

const ChangePassword = () => {
	const initialValues = { currentPassword: '', newPassword: '', confirmPassword: '' };
	const navigate = useNavigate();
	const { addToast, addDialog } = useFeedback();
	const { t } = useTranslation('translations');
	const { user } = useAuth();
	const { setTitle } = useTitleBar();

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setTitle(`${t('changeYourPassword')} - ${user?.name}`);
	}, [setTitle, t, user]);

	const changePasswordRequest = async (
		values: PasswordValues,
		formikHelpers: FormikHelpers<PasswordValues>,
	) => {
		setLoading(true);
		authApi.changePassword(values.currentPassword, values.newPassword)
			.then((res) => {
				addToast({ message: res.message, error: false });
				navigate(AppRoutes.DASHBOARD);
			})
			.catch(({ response }) => {
				addDialog({
					title: response.data.title,
					message: response.data.message,
					error: true,
				});
			})
			.finally(() => {
				formikHelpers.setSubmitting(false);
				setLoading(false);
			});

		return null;
	};

	const validatePassword = (values: PasswordValues) => {
		const errors: Partial<PasswordValues> = {};
		if (!values.currentPassword) {
			errors.currentPassword = t('emptyField');
		}
		if (!values.newPassword) {
			errors.newPassword = t('emptyField');
		}
		if (!values.confirmPassword) {
			errors.confirmPassword = t('emptyField');
		}
		if (values.confirmPassword !== values.newPassword) {
			errors.confirmPassword = t('passwordMatch');
		}
		return errors;
	};

	return (
		<ChangePasswordPage
			initialValues={initialValues}
			submit={changePasswordRequest}
			validate={validatePassword}
			loading={loading}
		/>
	);
};

export default ChangePassword;
